export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container">
        <p className="hero-eyebrow">Strategy · Design · Engineering</p>
        <h1>
          Build <span className="accent">with intent</span>,
          <br />
          ship with confidence.
        </h1>
        <p className="lede">
          Northwind Atlas helps product teams turn ambitious ideas into shipped software.
          We bring senior strategists, designers, and engineers to your hardest quarter —
          and stay long enough to make the next one easier.
        </p>
        <div className="hero-actions">
          <a href="#contact" className="btn btn-primary btn-large">
            Start a project
          </a>
          <a href="#services" className="btn btn-large">
            How we work
          </a>
        </div>
      </div>
    </section>
  );
}
